import * as React from "react";
import { FormControl, IconButton, Input, InputAdornment } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postTodos } from "api/all.api";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  borderRadius: "0",
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function AddTodo({ setOpen }) {
  const [input, setInput] = React.useState("");

  const queryClient = useQueryClient();
  const addMutation = useMutation({
    mutationFn: postTodos,
    onSuccess: (data) => {
      if (data?.error) throw data.error;
      else {
        queryClient.setQueryData(["todos"], (oldTodos) => [
          ...oldTodos,
          data.todo,
        ]);
        setOpen(false);
        setInput("");
        toast.success(data.message);
      }
    },
    onError: (err) => {
      toast.error(err);
      console.log("Error : ", err);
    },
  });

  const handleAdd = () => {
    const data = {
      todo: input,
      isComplete: false,
    };

    addMutation.mutate(data);
  };

  return (
    <Item>
      <FormControl
        sx={{
          mb: 1,
          mt: 2,
          width: "100%",
          paddingLeft: "20px",
          paddingRight: "20px",
        }}
        variant="standard">
        <Input
          id="standard-adornment-password"
          type={"text"}
          placeholder="Todo..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          size="small"
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleAdd}>
                <AddIcon />
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    </Item>
  );
}
